export class ListDataCatalogChildrenResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<DataCatalogTreeItem>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogChildrenResponse.attributeTypeMap;
    }
    constructor() {
    }
}
